import config from "../config";
import { Sparkles } from "lucide-react";

export default function MaintenanceScreen({ headline, message, compact = false }) {
  const title = headline || "We're working on this page";
  const body = message || "to bring good changes for you. We'll be back shortly.";

  return (
    <div
      data-testid="maintenance-screen"
      className={`relative overflow-hidden ${compact ? "min-h-[70vh]" : "min-h-screen"} bg-[#311b52] text-white`}
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 -left-16 h-80 w-80 rounded-full bg-[#f37721]/25 blur-3xl animate-pulse" />
        <div className="absolute top-1/3 -right-10 h-96 w-96 rounded-full bg-[#673c96]/50 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
      </div>

      <div className="relative z-10 min-h-inherit flex flex-col items-center justify-center px-6 py-16 text-center">
        <img
          src={config.LOGO_URL}
          alt="BookMyJab"
          className="h-auto w-48 md:w-56 mb-8"
          style={{ filter: "brightness(0) invert(1)" }}
        />
        <div className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-1.5 text-[11px] tracking-[0.18em] uppercase text-white/80 mb-6">
          <Sparkles className="w-3.5 h-3.5 text-[#f37721]" />
          A little care, in progress
        </div>
        <h1
          className="max-w-2xl text-3xl md:text-5xl font-bold leading-tight"
          style={{ fontFamily: "Poppins" }}
        >
          {title}
        </h1>
        <p
          className="mt-4 max-w-xl text-base md:text-lg text-white/80 leading-relaxed"
          style={{ fontFamily: "Montserrat" }}
        >
          {body}
        </p>
        <div className="mt-10 flex items-center gap-2 text-[#f37721]">
          <span className="h-2 w-2 rounded-full bg-[#f37721] animate-bounce" />
          <span className="h-2 w-2 rounded-full bg-[#f37721] animate-bounce [animation-delay:150ms]" />
          <span className="h-2 w-2 rounded-full bg-[#f37721] animate-bounce [animation-delay:300ms]" />
        </div>
        <p className="mt-8 text-xs text-white/50" style={{ fontFamily: "Montserrat" }}>
          BookMyJab · Uncompromising Care. Seamlessly Yours.
        </p>
      </div>
    </div>
  );
}
